<template>
    <div class="name-icon" :title="name">
        <div class="icon" :style="{background: color}">{{ initials }}</div>
        <div v-if="showName" class="name">
            <editable-text v-if="editable" v-model="name"></editable-text>
            <template v-else>{{ name }}</template>
        </div>
    </div>
</template>

<script>
import utils from "@/mixins/utils";
import EditableText from "@/Components/Common/EditableText";
export default {
    name: "NameIcon",
    components: {EditableText},
    emits: ['change'],
    mixins: [utils],

    props: {
        value: {
            type: Object,
            default: () => {},
        },
        showName: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        name:{
            get(){
                if( this.value && typeof this.value.display_name !== 'undefined' ){
                    return this.value.display_name;
                }

                if( this.value && typeof this.value.name !== 'undefined' ){
                    return this.value.name;
                }

                return '';
            },
            set(value){
                this.value.name = value;
                this.$emit('change', value);
            }
        },

        initials(){
            try{ return this.utils.initials( this.name ); } catch (e) {}
            return '';
        },
        color(){
            try{ return this.value.meta.color } catch (e) {}
            return '#303030';
        },
    },

    beforeMount() {
        // console.log({value: this.value});
    }

}
</script>

<style lang="scss" scoped>
.name-icon{
    display: flex;
    align-items: center;
}
.icon{
    color: white;
    padding: 0.4rem;
    width: 2.6em;
    height: 2.6em;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: $font-weight-bold;
    border: white solid 2px;
    box-shadow: $box-shadow-sm;
    text-decoration: none;
    background: #303030;
}
.name{
    margin-left: 0.4rem;
    font-weight: $font-weight-bold;
}
</style>
